import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { loadCustomers } from '../../../ducks/customers'
import { loadProjects, updateProject } from '../../../ducks/projects'
import { push } from 'react-router-redux'

function mapStateToProps (state, ownProps) { // eslint-disable-line no-unused-vars
  const id = ownProps.match.params.id
  const project = state.projects.list.reduce((found, p) => {
    if (p.id === id) {
      found = p
    }
    return found
  }, null)

  return {
    ...ownProps,
    id,
    project,
    customersFetched: state.customers.fetched,
    customersFetching: state.customers.fetching,
    customers: state.customers.list,
    projectsFetched: state.projects.fetched,
    projectsFetching: state.projects.fetching,
    projects: state.projects.list,
    user: state.auth.user
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    loadCustomers,
    loadProjects,
    updateProject,
    navigateTo: push
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/projects/create/index.js